export type Modifier = string | Array<string | boolean> | boolean;
export type ClassNameGenerator = (modifier: Modifier) => string;

/**
 * Utility function for creating class names.
 *
 * Supplying a base class and a modifier will give you a full class name string.
 *  Usage:
 *      createClassNames("ExampleBaseCssClass")("section")
 *
 *  Result:
 *      "ExampleBaseCssClass--section"
 *
 *
 * Supplying only a base class will give you a modifier function.
 *  Usage:
 *      const c = createClassNames("ExampleBaseCssClass");
 *      c(["header", "bold", "whatever"])
 *
 *  Result: "ExampleBaseCssClass--header ExampleBaseCssClass--bold ExampleBaseCssClass--whatever"
 *
 * @param baseClassName: your base css class name
 */
const createClassNames = (baseClassName: string): ClassNameGenerator => (modifier?: Modifier): string => {
    if (modifier === "" || typeof modifier === "boolean" || !modifier) return baseClassName;
    if (typeof modifier === "string") return baseClassName + "--" + modifier;
    return modifier.map((m: string | boolean) => createClassNames(baseClassName)(m)).join(" ");
};

export { createClassNames };
